// src/context/PurchaseOrdersContext.js
import React, { createContext, useContext, useState, useEffect } from "react";
import axios from "axios";

const PurchaseOrdersContext = createContext();

export const usePurchaseOrders = () => {
  const context = useContext(PurchaseOrdersContext);
  if (!context) {
    throw new Error(
      "usePurchaseOrders must be used within a PurchaseOrdersProvider"
    );
  }
  return context;
};

export const PurchaseOrdersProvider = ({
  children,
  endpoint0,
  endpoint1,
  endpoint2,
  endpoint3,
  endpoint4,
  endpoint5,
  endpoint6,
  endpoint7,
}) => {

  const baseUrl = process.env.REACT_APP_BASE_URL;
  const [purchaseOrders, setPurchaseOrders] = useState([]);
  const [purchaseOrders1, setPurchaseOrders1] = useState([]);
  const [purchaseOrders2, setPurchaseOrders2] = useState([]);
  const [purchaseOrders3, setPurchaseOrders3] = useState([]);
  const [purchaseOrders4, setPurchaseOrders4] = useState([]);
  const [purchaseOrders5, setPurchaseOrders5] = useState([]);
  const [purchaseOrders6, setPurchaseOrders6] = useState([]);
  const [purchaseOrders7, setPurchaseOrders7] = useState([]);

  const [goods, setGoods] = useState([]);
  const [categories, setCategories] = useState([]);
  const [suppliers, setSuppliers] = useState([]);

  const [total, setTotal] = useState(0);
  const [total1, setTotal1] = useState(0);
  const [total2, setTotal2] = useState(0);
  const [total3, setTotal3] = useState(0);
  const [total4, setTotal4] = useState(0);
  const [total5, setTotal5] = useState(0);
  const [total6, setTotal6] = useState(0);
  const [total7, setTotal7] = useState(0);

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // hardcoded storeIds for each API
  const STORE_ID_0 = "688b8cbab2056ab08208c7b1"; // Falak
  const STORE_ID_1 = "6720fcb3f2db35c9580c8dbe"; // Jumeirah Park
  const STORE_ID_2 = "6544998d77d8fcd5850d09d9"; // Padel Club
  const STORE_ID_3 = "68d4fb0fa84663315a09dd58"; // Golden Mile
  const STORE_ID_4 = "68d78034c7907180ea01131a"; // Meadows Village
  const STORE_ID_5 = "68d780b37f315dbe130f4f50"; // Forte Tower
  const STORE_ID_6 = "68d7815745ea495cf303c17b"; // Production Kitchen
  const STORE_ID_7 = "6921cc5aa537d69a4103aabb"; // Dubai Hills
  useEffect(() => {
    const fetchPurchaseOrders = async () => {
      try {
        const url =
          endpoint0 ||
          `${baseUrl}/api/purchase-orders/purchase-orders-api-0`;
        const response = await axios.get(url);

        setTotal(response.data.total || 0);

        const allPurchaseOrders = Object.values(response.data)
          .filter((storeData) => storeData?.data)
          .flatMap((storeData) =>
            storeData.data.map((po) => ({
              ...po,
              storeIndex: 0,
              storeId: STORE_ID_0, // ✅ attach real storeId
            }))
          );

        setPurchaseOrders(allPurchaseOrders);
      } catch (err) {
        console.error("Error fetching purchase orders for store 0:", err);
        setError("Wait to fetch purchase orders.");
        setPurchaseOrders([]);
        setTotal(0);
      } finally {
        setLoading(false);
      }
    };

    const fetchPurchaseOrders1 = async () => {
      try {
        const url =
          endpoint1 ||
          `${baseUrl}/api/purchase-orders/purchase-orders-api-1`;
        const response = await axios.get(url);

        setTotal1(response.data.total || 0);

        const allPurchaseOrders = Object.values(response.data)
          .filter((storeData) => storeData?.data)
          .flatMap((storeData) =>
            storeData.data.map((po) => ({
              ...po,
              storeIndex: 1,
              storeId: STORE_ID_1, // ✅ attach real storeId
            }))
          );

        setPurchaseOrders1(allPurchaseOrders);
      } catch (err) {
        console.error("Error fetching purchase orders for store 1:", err);
        setError("Wait to fetch purchase orders.");
        setPurchaseOrders1([]);
        setTotal1(0);
      } finally {
        setLoading(false);
      }
    };

    const fetchPurchaseOrders2 = async () => {
      try {
        const url =
          endpoint2 ||
          `${baseUrl}/api/purchase-orders/purchase-orders-api-2`;
        const response = await axios.get(url);
        setTotal2(response.data.total || 0);
        const allPurchaseOrders = Object.values(response.data)
          .filter((storeData) => storeData?.data)
          .flatMap((storeData) =>
            storeData.data.map((po) => ({
              ...po,
              storeIndex: 2,
              storeId: STORE_ID_2,
            }))
          );
        setPurchaseOrders2(allPurchaseOrders);
      } catch (err) {
        console.warn("Store 2 not accessible or unauthorized:", err.message);
        // fallback → treat as empty
        setPurchaseOrders2([]);
        setTotal2(0);
      } finally {
        setLoading(false);
      }
    };

    const fetchPurchaseOrders3 = async () => {
      try {
        const url =
          endpoint2 ||
          `${baseUrl}/api/purchase-orders/purchase-orders-api-3`;
        const response = await axios.get(url);
        setTotal3(response.data.total || 0);
        const allPurchaseOrders = Object.values(response.data)
          .filter((storeData) => storeData?.data)
          .flatMap((storeData) =>
            storeData.data.map((po) => ({
              ...po,
              storeIndex: 3,
              storeId: STORE_ID_3,
            }))
          );
        setPurchaseOrders3(allPurchaseOrders);
      } catch (err) {
        console.warn("Store 3 not accessible or unauthorized:", err.message);
        // fallback → treat as empty
        setPurchaseOrders3([]);
        setTotal3(0);
      } finally {
        setLoading(false);
      }
    };

    const fetchPurchaseOrders4 = async () => {
      try {
        const url =
          endpoint4 ||
          `${baseUrl}/api/purchase-orders/purchase-orders-api-4`;
        const response = await axios.get(url);
        setTotal4(response.data.total || 0);
        const allPurchaseOrders = Object.values(response.data)
          .filter((storeData) => storeData?.data)
          .flatMap((storeData) =>
            storeData.data.map((po) => ({
              ...po,
              storeIndex: 4,
              storeId: STORE_ID_4,
            }))
          );
        setPurchaseOrders4(allPurchaseOrders);
      } catch (err) {
        console.warn("Store 4 not accessible or unauthorized:", err.message);
        // fallback → treat as empty
        setPurchaseOrders4([]);
        setTotal4(0);
      } finally {
        setLoading(false);
      }
    };

    const fetchPurchaseOrders5 = async () => {
      try {
        const url =
          endpoint5 ||
          `${baseUrl}/api/purchase-orders/purchase-orders-api-5`;
        const response = await axios.get(url);
        setTotal3(response.data.total || 0);
        const allPurchaseOrders = Object.values(response.data)
          .filter((storeData) => storeData?.data)
          .flatMap((storeData) =>
            storeData.data.map((po) => ({
              ...po,
              storeIndex: 5,
              storeId: STORE_ID_5,
            }))
          );
        setPurchaseOrders5(allPurchaseOrders);
      } catch (err) {
        console.warn("Store 5 not accessible or unauthorized:", err.message);
        // fallback → treat as empty
        setPurchaseOrders5([]);
        setTotal5(0);
      } finally {
        setLoading(false);
      }
    };

    const fetchPurchaseOrders6 = async () => {
      try {
        const url =
          endpoint6 ||
          `${baseUrl}/api/purchase-orders/purchase-orders-api-6`;
        const response = await axios.get(url);
        setTotal6(response.data.total || 0);
        const allPurchaseOrders = Object.values(response.data)
          .filter((storeData) => storeData?.data)
          .flatMap((storeData) =>
            storeData.data.map((po) => ({
              ...po,
              storeIndex: 6,
              storeId: STORE_ID_6,
            }))
          );
        setPurchaseOrders6(allPurchaseOrders);
      } catch (err) {
        console.warn("Store 6 not accessible or unauthorized:", err.message);
        // fallback → treat as empty
        setPurchaseOrders6([]);
        setTotal6(0);
      } finally {
        setLoading(false);
      }
    };

    const fetchPurchaseOrders7 = async () => {
      try {
        const url =
          endpoint7 ||
          `${baseUrl}/api/purchase-orders/purchase-orders-api-7`;
        const response = await axios.get(url);
        setTotal7(response.data.total || 0);
        const allPurchaseOrders = Object.values(response.data)
          .filter((storeData) => storeData?.data)
          .flatMap((storeData) =>
            storeData.data.map((po) => ({
              ...po,
              storeIndex: 7,
              storeId: STORE_ID_7,
            }))
          );
        setPurchaseOrders7(allPurchaseOrders);
      } catch (err) {
        console.warn("Store 7 not accessible or unauthorized:", err.message);
        // fallback → treat as empty
        setPurchaseOrders7([]);
        setTotal7(0);
      } finally {
        setLoading(false);
      }
    };

    const fetchGoods = async () => {
      try {
        const response = await axios.get(
          `${baseUrl}/api/purchase-orders/good-api`
        );
        const allGoods = response.data.flatMap((item) => item.data || []);
        setGoods(allGoods);
      } catch (err) {
        console.error("Error fetching goods:", err);
        setError("Wait to fetch goods.");
        setGoods([]);
      } finally {
        setLoading(false);
      }
    };

    const fetchSuppliers = async () => {
      try {
        const response = await axios.get(
          `${baseUrl}/api/purchase-orders/suppliers-api`
        );
        const allSuppliers = response.data.flatMap((item) => item.data || []);
        setSuppliers(allSuppliers);
      } catch (err) {
        console.error("Error fetching suppliers:", err);
        setError("Wait to fetch suppliers.");
        setSuppliers([]);
      } finally {
        setLoading(false);
      }
    };

    const fetchCategories = async () => {
      try {
        const response = await axios.get(
          `${baseUrl}/api/purchase-orders/categories-api`
        );
        const allCategories = response.data.flatMap((item) => item.data || []);
        setCategories(allCategories);
      } catch (err) {
        console.error("Error fetching categories:", err);
        setError("Wait to fetch categories.");
        setCategories([]);
      } finally {
        setLoading(false);
      }
    };

    // Run all fetches
    fetchGoods();
    fetchCategories();
    fetchSuppliers();
    fetchPurchaseOrders();
    fetchPurchaseOrders1();
    fetchPurchaseOrders2();
    fetchPurchaseOrders3();
    fetchPurchaseOrders4();
    fetchPurchaseOrders5();
    fetchPurchaseOrders6();
    fetchPurchaseOrders7();
  }, [
    endpoint0,
    endpoint1,
    endpoint2,
    endpoint3,
    endpoint4,
    endpoint5,
    endpoint6,
    endpoint7,
  ]);

  return (
    <PurchaseOrdersContext.Provider
      value={{
        purchaseOrders,
        total,
        goods,
        categories,
        suppliers,
        purchaseOrders1,
        purchaseOrders2,
        purchaseOrders3,
        purchaseOrders4,
        purchaseOrders5,
        purchaseOrders6,
        purchaseOrders7,
        total1,
        total2,
        total3,
        total4,
        total5,
        total6,
        total7,
        loading,
        error,
      }}
    >
      {children}
    </PurchaseOrdersContext.Provider>
  );
};
